<form class="align-items-center" (ngSubmit)="saveContratAssocie()" [formGroup]="contratsAssociesForm">
  <div class="field grid">
    <div class="col-16 mt-1 mb-2 md:col-12">
      <p-table
        #ctasTable
        [value]="contratsFormArray.controls"
        [scrollable]="true"
        [rows]="10"
        scrollHeight="300px"
        selectionMode="multiple"
        [(selection)]="selectedContrats"
        [totalRecords]="contratsFormArray.controls.length"
        styleClass="p-datatable-striped"
        dataKey="value.id"
        [tableStyle]="{ 'min-width': '75rem' }"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Enregistrements {totalRecords}"
      >
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th>Libellé</th>
            <th>Entité de Gestion</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-contratAssocies let-index="rowIndex" let-editing="editing">
          <ng-container formArrayName="contratsArray">
            <tr [formGroupName]="index" [pSelectableRow]="contratsFormArray.controls[index]">
              <td>
                <p-checkbox formControlName="associated" [binary]="true" />
              </td>
              <td>{{ contratsFormArray.getRawValue()[index].libelle }}</td>
              <td>{{ contratsFormArray.getRawValue()[index].entiteGestion }}</td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="field grid">
    <div class="flex justify-content-center">
      <p-button label="{{ 'button.validate' | transloco }}" pRipple [rounded]="true" type="submit" />
      <p-button label="{{ 'button.cancel' | transloco }}" pRipple [rounded]="true" (click)="close(false)" [outlined]="true" />
    </div>
  </div>
</form>

<p-toast />
